var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "azSize container" },
    [
      _c("H1", { staticClass: "pageTitle isPoppins is-size-2" }, [
        _vm._v("Analytics:  \n        \n    ")
      ]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.noShow,
            expression: "!noShow"
          }
        ],
        staticClass: "right3 is-size-2",
        attrs: { src: require("@/assets/img/chevronsW.png"), width: "28" }
      }),
      _c("span", { staticClass: "has-text-yell is-size-2" }, [
        _vm._v(_vm._s(_vm.slink))
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.noShow,
              expression: "!noShow"
            }
          ]
        },
        [
          _c("div", { staticClass: "has-text-white wideLimitWidth" }, [
            _vm._v(
              "This view shows the number of times your slink and subslinks have been used and a summary of the locations from which they were accessed. Select a date range to filter your results."
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top10" }, [
            _vm._v("*Values are updated several times per day")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("date-range-picker", {
            staticClass: "has-text-dark",
            attrs: {
              opens: "'left'",
              maxDate: new Date(),
              minDate: new Date(2022, 3, 15)
            },
            on: { update: _vm.updateValues },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function(header) {
                  return _c("div", { staticClass: "slot" })
                }
              },
              {
                key: "input",
                fn: function(picker) {
                  return [
                    _c("div", [
                      _vm._v(
                        "Date Range: " +
                          _vm._s(_vm._f("date")(picker.startDate)) +
                          " - " +
                          _vm._s(_vm._f("date")(picker.endDate)) +
                          "  "
                      ),
                      _c("i", { staticClass: "fa fa-angle-down" })
                    ])
                  ]
                }
              },
              {
                key: "date",
                fn: function(data) {
                  return [
                    _c("span", { staticClass: "small" }, [
                      _vm._v(_vm._s(_vm._f("dateCell")(data.date)))
                    ])
                  ]
                }
              },
              {
                key: "ranges",
                fn: function(ranges) {
                  return [
                    _c("div", { staticClass: "ranges" }, [
                      _c(
                        "ul",
                        _vm._l(ranges.ranges, function(range, name) {
                          return _c(
                            "li",
                            {
                              key: name,
                              on: {
                                click: function($event) {
                                  return ranges.clickRange(range)
                                }
                              }
                            },
                            [_c("b", [_vm._v(_vm._s(name))])]
                          )
                        }),
                        0
                      )
                    ])
                  ]
                }
              },
              {
                key: "footer",
                fn: function(data) {
                  return _c("div", { staticClass: "slot" }, [
                    _c("div", { staticClass: "has-text-centered bottom10" }, [
                      _c("div", [
                        _c("b", { staticClass: "text-black" }, [
                          _vm._v("Selected:")
                        ]),
                        _vm._v(
                          " " + _vm._s(data.rangeText) + "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "top10",
                          staticStyle: { "margin-left": "auto" }
                        },
                        [
                          !data.in_selection
                            ? _c(
                                "a",
                                {
                                  staticClass: "button is-warning is-small",
                                  on: { click: data.clickApply }
                                },
                                [_vm._v("APPLY")]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  ])
                }
              }
            ]),
            model: {
              value: _vm.dateRange,
              callback: function($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange"
            }
          }),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loaded,
                  expression: "!loaded"
                }
              ],
              staticClass: "is-size-2",
              attrs: { id: "loaderHolder" }
            },
            [_vm._v(" ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loaded,
                  expression: "loaded"
                }
              ]
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "has-text-centered mainAnalyticBlock is-inline-block"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "has-text-warning",
                      staticStyle: { "font-size": "120px" }
                    },
                    [_vm._v(_vm._s(_vm.rootTotal))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "top-20" }, [
                    _c("img", {
                      staticClass: "right3",
                      attrs: {
                        src: require("@/assets/img/chevronsT.png"),
                        width: "22"
                      }
                    }),
                    _c("span", { staticClass: "title has-text-turk" }, [
                      _vm._v(_vm._s(_vm.slink))
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "has-text-centered has-text-grey mainAnalyticBlock is-inline-block pad10",
                  staticStyle: { "border-left": "3px solid #ffb227" }
                },
                [
                  _c("div", { staticStyle: { "font-size": "120px" } }, [
                    _vm._v(_vm._s(_vm.combinedTotal))
                  ]),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "columns" }, [
                _c(
                  "div",
                  {
                    staticClass: "column",
                    staticStyle: { "max-width": "600px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "analyticsDiv" },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              { staticClass: "subTitle has-text-warning" },
                              [
                                _c("img", {
                                  staticClass: "right3",
                                  attrs: {
                                    src: require("@/assets/img/chevronsT.png"),
                                    width: "18"
                                  }
                                }),
                                _vm._v(_vm._s(_vm.slink) + " - "),
                                _c("span", { staticClass: "has-text-white" }, [
                                  _vm._v(
                                    _vm._s(_vm.findCombined(_vm.root.hits))
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.root.hits, function(c, ind) {
                              return _c(
                                "div",
                                { key: ind, staticClass: "left10" },
                                [
                                  c.code != "*"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(c.num) +
                                            " - " +
                                            _vm._s(_vm.getCity(c.code))
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.subs, function(i, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "bottom10" },
                            [
                              _c(
                                "div",
                                { staticClass: "subTitle has-text-warning" },
                                [
                                  _vm._v(
                                    ":" + _vm._s(i.path.split(":")[1]) + " - "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "has-text-white" },
                                    [_vm._v(_vm._s(_vm.findCombined(i.hits)))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(i.hits, function(c, ind) {
                                return _c(
                                  "div",
                                  { key: ind, staticClass: "left10" },
                                  [
                                    c.code != "*"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(c.num) +
                                              " - " +
                                              _vm._s(_vm.getCity(c.code))
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.noShow,
              expression: "noShow"
            }
          ],
          staticClass: "has-text-dark"
        },
        [
          _c("b", [
            _vm._v(
              "Sorry, there is no slink data to show or you are not authorized to view this information."
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _c("br"),
      _c("br")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-20" }, [
      _c("span", { staticClass: "title has-text-grey" }, [_vm._v("+subslinks")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0910824f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0910824f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Metrics.vue
// module id = null
// module chunks = 